import React from 'react';
import { useParams } from 'react-router-dom';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent.jsx';

const NewFolder = () => {
  const { folderType: urlFolderType } = useParams();

  const getType = (newFolderType) => {
    let outType = '';
    if (newFolderType === 'customer') {
      outType = 'Kunden';
    } else if (newFolderType === 'supplier') {
      outType = 'Lieferanten';
    } else if (newFolderType === 'product') {
      outType = 'Produkt';
    }
    return outType;
  };

  const info = (folderType) => {
    let outElement = '';
    if(folderType === 'Kunden'){
      outElement = <p>Bitte an die Konvention für Kundenordner halten: <br /><b>"Nachname, Vorname, Firma, Netsuite-Kundennummer"</b><br /><br />Beispielsweise: <br />Malkov, Ruslan, ETM Russia, 100059<br />
      Windsport GmbH und Co KG, 100202<br />Czwalina, Jochen, 200417</p>;
    }
    if(folderType === 'Lieferanten'){
      outElement = <p>Bitte an die Konvention für Lieferanten halten: <br /><b>"Firmenname Netsuite-Lieferantennummer"</b><br /><br />Beispielsweise:
      <br />Overseas 770735<br />
      Sports-Equipment Consulting Ltd. 770775<br />Aqua Dynamics 760026</p>;
    }
    if(folderType === 'Produkt'){
      outElement = <p>Bitte an die Konvention für Produkte halten: <br /><b>"Produktname" "Version"</b></p>;
    }

    return outElement;
  };

  const folderType = getType(urlFolderType);

  return (
    <div className="home">
      <h1>NEUEN {folderType.toUpperCase()}ORDNER IM SHAREPOINT ANLEGEN.</h1>
      <p>
        Über diese Seite wird ein neuer {folderType}ordner mitsamt Unterordnern
        <br /> im SharePoint angelegt und die zugehörigen Rechte verteilt.
      </p>
      {info(folderType)}
      <br />
      <ButtonComponent folderType={folderType} />
    </div>
  );
};

export default NewFolder;
